

import { ChevronDown, Merge, Percent, Split } from 'lucide-react';
import React from 'react';
import { Button } from 'src/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'src/components/ui/dropdown-menu';
import DateRangeModal from './date-range-modal';

interface MenuBarProps {
  className?: string;
  selectedClassName?: string;
  onMergeToggle: () => void;
  onEditToggle: () => void;
  onSelectionChange: (selection: string) => void;
  onDateChange: (dateFilter: string, startDate?: string, endDate?: string) => void;
  editMode?: boolean;
  mergeMode?: boolean;
  selectedMetric?: string;
  selectedDate?: string;
}

const MenuBar: React.FC<MenuBarProps> = ({
  className = 'bg-gray-200 text-black rounded-full',
  selectedClassName = 'bg-blue-500 text-white',
  onMergeToggle,
  onEditToggle,
  onSelectionChange,
  onDateChange,
  editMode = false,
  mergeMode = false,
  selectedMetric = 'Clicks',
  selectedDate = 'last_week',
}) => {

  return (
    <div className="flex items-center justify-between w-full">
      <div>
        <Button
          className={`ml-2 ${className} hover:opacity-65 ${mergeMode ? selectedClassName : ''}`}
          variant="ghost"
          size="med"
          onClick={() => onMergeToggle()}
        >
          {!mergeMode ? <Merge className="w-4 h-4" /> : <Split className="w-4 h-4" />}
        </Button>
        { selectedMetric === 'Spend' && (
          <Button
            className={`ml-2 ${editMode ? selectedClassName : className} hover:opacity-65`}
            variant="ghost"
            size="med"
            onClick={() => onEditToggle()}
          >
            <Percent className="w-4 h-4" />
          </Button>
        )}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              className={`ml-2 ${className} hover:opacity-65`}
              variant="ghost"
              size="med"
            >
              <ChevronDown className="w-4 h-4" />
              {selectedMetric}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onClick={() => onSelectionChange('Clicks')}>
              Clicks
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onSelectionChange('Impressions')}>
              Impressions
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onSelectionChange('Conversions')}>
              Conversions
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onSelectionChange('Spend')}>
              Spend
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div className='flex items-center gap-2 mr-2'>
        <Button
          className={`${className} hover:opacity-65 ${selectedDate === 'last_week' ? selectedClassName : ''}`}
          variant="primary"
          size="med"
          onClick={() => onDateChange('last_week')}
        >
          Last week
        </Button>

        <Button
          className={`${className} hover:opacity-65 ${selectedDate === 'last_month' ? selectedClassName : ''}`}
          variant="ghost"
          size="med"
          onClick={() => onDateChange('last_month')}
        >
          Last month
        </Button>

        <Button
          className={`${className} hover:opacity-65 ${selectedDate === 'this_month' ? selectedClassName : ''}`}
          variant="ghost"
          size="med"
          onClick={() => onDateChange('this_month')}
        >
          This month
        </Button>

        <DateRangeModal
          className={className}
          selectedClassName={selectedClassName}
          selectedDate={selectedDate}
          onDateChange={onDateChange}
        />

      </div>
    </div>
  );
};

export default MenuBar;
